import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var DashedBulletsIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7388 3.11864C15.7388 2.50083 16.2397 2 16.8575 2H43.7049C44.3227 2 44.8236 2.50083 44.8236 3.11864C44.8236 3.73645 44.3227 4.23729 43.7049 4.23729H16.8575C16.2397 4.23729 15.7388 3.73645 15.7388 3.11864Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7388 24C15.7388 23.3822 16.2397 22.8814 16.8575 22.8814H43.7049C44.3227 22.8814 44.8236 23.3822 44.8236 24C44.8236 24.6178 44.3227 25.1186 43.7049 25.1186H16.8575C16.2397 25.1186 15.7388 24.6178 15.7388 24Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7388 44.8814C15.7388 44.2635 16.2397 43.7627 16.8575 43.7627H43.7049C44.3227 43.7627 44.8236 44.2635 44.8236 44.8814C44.8236 45.4992 44.3227 46 43.7049 46H16.8575C16.2397 46 15.7388 45.4992 15.7388 44.8814Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18018 3.11864C3.18018 2.50083 3.68101 2 4.29882 2H8.8778C9.49561 2 9.99645 2.50083 9.99645 3.11864C9.99645 3.73645 9.49561 4.23729 8.8778 4.23729H4.29882C3.68101 4.23729 3.18018 3.73645 3.18018 3.11864Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18018 24C3.18018 23.3822 3.68101 22.8814 4.29882 22.8814H8.8778C9.49561 22.8814 9.99645 23.3822 9.99645 24C9.99645 24.6178 9.49561 25.1186 8.8778 25.1186H4.29882C3.68101 25.1186 3.18018 24.6178 3.18018 24Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18018 44.8814C3.18018 44.2635 3.68101 43.7627 4.29882 43.7627H8.8778C9.49561 43.7627 9.99645 44.2635 9.99645 44.8814C9.99645 45.4992 9.49561 46 8.8778 46H4.29882C3.68101 46 3.18018 45.4992 3.18018 44.8814Z"
  }));
});
DashedBulletsIcon.displayName = 'DashedBulletsIcon';
DashedBulletsIcon.defaultProps = {
  'aria-label': 'DashedBullets'
};
export default DashedBulletsIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/DashedBulletsIcon/index.js
// module id = 1824
// module chunks = 12